import { Link } from "react-router-dom";
import type { ItemDto } from "../api/types.js";
import { formatCount, formatRelative, kindLabel, skinFilterLabel } from "../lib/format.js";

const KIND_EMOJI: Record<string, string> = {
  sticker: "🎫",
  keychain: "🔑",
  skin: "🔫",
};

export function ItemCard({ item }: { item: ItemDto }) {
  return (
    <Link
      to={`/items/${item.id}`}
      className="block rounded-2xl bg-bg-secondary p-4 transition active:scale-[0.99]"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5 text-xs uppercase tracking-wide text-hint">
            <span>{KIND_EMOJI[item.kind] ?? "•"}</span>
            <span>{kindLabel(item.kind)}</span>
            {skinFilterLabel(item.filter) && (
              <span className="rounded-md bg-bg px-1.5 py-0.5 normal-case tracking-normal text-text">
                {skinFilterLabel(item.filter)}
              </span>
            )}
            {!item.isActive && (
              <span className="rounded-full bg-destructive/20 px-2 py-0.5 text-destructive">
                inactive
              </span>
            )}
          </div>
          <div className="mt-1 truncate text-base font-semibold">{item.displayName}</div>
          {item.tags.length > 0 && (
            <div className="mt-1 flex flex-wrap gap-1">
              {item.tags.map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-bg px-2 py-0.5 text-[10px] text-hint"
                >
                  {t}
                </span>
              ))}
            </div>
          )}
          {item.lastCountByMultiplicity && item.lastCountByMultiplicity.x5 > 0 && (
            <div className="mt-1 inline-block rounded-full bg-button/15 px-2 py-0.5 text-[10px] font-medium text-button">
              🔥 ×5: {item.lastCountByMultiplicity.x5}
            </div>
          )}
          <div className="mt-1 text-xs text-hint">
            {formatRelative(item.lastSnapshotAt)}
          </div>
        </div>
        <div className="text-right">
          <div className="text-2xl font-bold tabular-nums">{formatCount(item.lastCount)}</div>
          <div className="text-xs text-hint">items</div>
        </div>
      </div>
    </Link>
  );
}
